// ecomm.ski cart bootstrap (module). One petite-vue app per line, one submit handler, re-mounts after Dawn re-renders the cart.
// petite-vue 0.4.1 (ag-petite-vue.js) and maska 2.1.11 (ag-maska.js) are vendored in this theme: no third-party CDN.
// All three modules are loaded with import() from versioned asset URLs (see snippets/ag-ecommski-settings.liquid),
// because a relative import carries no ?v= and a browser/CDN could serve a stale copy after a deploy.

const SELECTOR = '.ag-ski-cart-item-container .ski-cart-item';
let SkiItem = null;
let createApp = null;
let MaskInput = null;

function mountNew() {
  if (!SkiItem || !createApp || !MaskInput) return;
  document.querySelectorAll(SELECTOR).forEach((el) => {
    if (el.dataset.agMounted) return;
    el.dataset.agMounted = '1';
    // Dawn's <cart-items> treats every bubbling "change" as a quantity edit (validateQuantity -> setCustomValidity),
    // which would flag name / date / talon fields as invalid and block the cart form. Our fields use input/blur only.
    const container = el.closest('.ag-ski-cart-item-container');
    if (container) container.addEventListener('change', (event) => event.stopPropagation());
    createApp({ SkiItem }).mount(el);
    // maska's directive is Vue 3 only; like the live theme, attach the mask to the input itself.
    el.querySelectorAll('[data-maska]').forEach((input) => new MaskInput(input));
  });
  document.documentElement.classList.add('ag-ski-ready');
}

// After a failed submit: bring the first problem into view (on mobile it can be far above the checkout button).
function revealFirstError() {
  // First message in DOM order. (The photo input is display:none, so it cannot be the scroll target.)
  const target = document.querySelector('.ski-cart-item .ag-field__error, .ski-cart-item .ski-cart-item__error');
  if (!target) return;
  target.scrollIntoView({ block: 'center', behavior: 'smooth' });
  const scope = target.closest('.ag-field, .ag-dob');
  const input = scope && scope.querySelector('input[aria-invalid="true"]:not([type="file"])');
  if (input) input.focus({ preventScroll: true });
}

// Single submit handler on form#cart (the live theme added one per cart line).
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'cart') return;
    if (!document.querySelector(SELECTOR)) return; // cart without ski lines: leave Dawn alone

    event.preventDefault();
    event.stopImmediatePropagation();

    window.globalValidationState = [];
    window.skiPassItemsSubmitted = 0;

    // Drop components whose DOM was replaced by a cart re-render
    const registry = (window.agSki && window.agSki.items) || new Set();
    registry.forEach((item) => {
      if (!item._el || !item._el.isConnected) registry.delete(item);
    });
    [...registry].forEach((item) => item.save());

    // item.save() validates synchronously; give petite-vue a tick to render the messages
    setTimeout(() => {
      if (window.globalValidationState.some((state) => !state.isValid)) revealFirstError();
    }, 80);
  },
  true
);

// Dawn replaces cart markup after quantity change / removal: mount the new lines.
new MutationObserver(() => mountNew()).observe(document.body, { childList: true, subtree: true });

const urls = window.ecommSkiSettings;
Promise.all([import(urls.petiteVueUrl), import(urls.maskaUrl), import(urls.cartItemModuleUrl)])
  .then(([vue, maska, item]) => {
    createApp = vue.createApp;
    MaskInput = maska.MaskInput;
    SkiItem = item.SkiItem;
    mountNew();
  })
  .catch((error) => console.error('ecomm.ski cart modules failed to load: ', error));
